import React, { useEffect, useMemo, useState } from 'react'
import { Card, CardBody, Col, Container, Modal, ModalBody, ModalHeader, Row } from 'reactstrap'
import CommonService from 'services/CommonService';
import { IColumnModel } from 'models/IColumnModel';
import CustomDataTable from 'components/shared/CustomDataTable';
import { TablePagePerView } from 'components/constants/dsmConstants';
import { RoleModel } from 'models/IRole.Model';
import { ISearchModel } from 'models/ISearch.Model';
import { IGetFeedBackDetail } from 'models/IGetFeedBackDetail';
import CorporateTrendPopUp from './CorporateTradePopUp';
import { useTypedSelector } from 'features/reduxhooks/ReduxHooks';
import AddrssTypeServices from 'services/AddrssType.Services';
import { HelperConstant } from '../../helpers/HelperConstant';
import UseDebounce from 'components/shared/UseDebounce';
import StatusStatsFilters from 'components/filter/StatusStatsFilters';
import { downloadCSV, downloadMobileInvoice } from '../../helpers/Helper';
import { Capacitor } from '@capacitor/core';
import CustomLoader from 'components/Common/CustomLoader';

function CorporateInTrade() {
    const [editModal, setEditModal] = useState(0);
    const [searchText, setSearchText] = useState<any>();
    const [selectedColumn, setSelectedColumn] = useState("");
    const [sortOrder, setSortOrder] = useState("");
    const [search, setSearch] = useState("");
    const [corporateData, setcorporateData] = useState<Array<any>>([]);
    const [totalRecords, setTotalRecords] = useState<number>(0);
    const [statusList, setStatusList] = useState<Array<any>>([]);
    const [isStatusId, setIsStatusId] = useState(HelperConstant.Corporate_Trade_In_StatusIds.Open);
    const [isload, setIsLoad] = useState(false);
    const debouncedSearch = UseDebounce(searchText, 1000);
    const [fromDate, setFromDate] = useState<string | null>(null);
    const [toDate, setToDate] = useState<string | null>(null);

    const [rowsPerPage] = useState<number>(50);
    const [currentPage, setCurrentPage] = useState<any>(1);
    const [offsetStart, setOffsetStart] = useState<number>(0);

    const statusName = isStatusId ? statusList.filter(x => x.Id == isStatusId)[0]?.Name : HelperConstant.Corporate_Trade_In_StatusEnums.Open;

    const columns: IColumnModel[] = useMemo(() => [
        {
            Header: 'Created On',
            accessor: 'Created',
            width: "10%",
            displayInList: true,
            Filter: true,
            datatype: "date"
        },
        {
            Header: 'Code',
            accessor: 'CorporateTradeInCode',
            displayInList: true,
            width: "10%",
            Filter: false,
            datatype: "linkbtn"
        },
        {
            Header: 'Name',
            accessor: 'Name',
            width: "10%",
            displayInList: true,
            Filter: false
        },
        {
            Header: 'Email',
            accessor: 'Email',
            width: "20%",
            displayInList: true,
            Filter: false
        }, {
            Header: 'Mobile',
            accessor: 'Mobile',
            displayInList: true,
            width: "10%",
            Filter: false
        }, {
            Header: 'Subject',
            accessor: 'Subject',
            displayInList: true,
            width: "30%",
            Filter: false
        },
        {
            Header: 'Status',
            accessor: 'StatusName',
            displayInList: true,
            width: "30%",
            Filter: false
        },
    ], []);


    const searchByText = (pageNumber: any, searchText: any, statusid: any, sortcolumn?: string, sortorder?: string) => {
        setIsLoad(true);
        getStatus()
        let searchModel: ISearchModel = {
            offsetStart: offsetStart,
            rowsPerPage: rowsPerPage,
            sortOrder: "desc",
            sortOrderColumn: "modified",
            searchText: searchText,
            FeedbackStatusId: statusid ? parseInt(statusid) : HelperConstant.Corporate_Trade_In_StatusIds.Open,
            FromDate: fromDate,
            ToDate: toDate,
            IsContactUs:false
        }

        CommonService.post('addressType', 'GetContactusOrCorporatetrade', searchModel).then(res => {
            if (res.status == 200) {
                let data: Array<IGetFeedBackDetail> = res.data
                setcorporateData(data);
                setTotalRecords(data[0]?.TotalRowsCount);
                setIsLoad(false);
            }
        });
    }
    const getStatus = () => {
        AddrssTypeServices.GetCorporateTradeInStats(HelperConstant.EntityTypeId.BECOME_A_PARTNER).then(res => {
            if (res.status === 200) {
                setStatusList(res.data);
            }
        }).catch(e => {
            console.log(e);
        });
    }
    const editHandler = (val) => {
        setEditModal(val.Id);
    }

    const searchHandler = (searchKeyword: any) => {
        setSearchText(searchKeyword);
        searchByText(0, searchKeyword, isStatusId);
    }

    const onColumnSortChange = (columnName, sortorder) => {
        setSelectedColumn(columnName);
        setSortOrder(sortorder);
    };

    const pagination = (pageNumber: any) => {
        searchByText(pageNumber, debouncedSearch, isStatusId, selectedColumn, sortOrder);
    }

    const code = corporateData.find(corporate => corporate.Id === editModal);


    const getCorporateTradeInExport = () => {
        setIsLoad(true);
        const fileName = `DOFY_CorporateTradeInList_${statusName}`;

        AddrssTypeServices.GetCorporateTradeInExport({
            SortOrder: "desc",
            SortOrderColumn: "modified",
            FeedbackStatusId: isStatusId ? isStatusId : HelperConstant.Corporate_Trade_In_StatusIds.Open,
            searchText: debouncedSearch,
            FromDate: fromDate,
            ToDate: toDate,
            ContactType: 2,
            offsetStart: null,
            rowsPerPage: null

        }).then(res => {
            if (res.status === 200) {
                if (Capacitor.isNativePlatform()) {
                    let concatedBase64 = "data:application/octet-stream;base64, " + res.data;
                    downloadMobileInvoice(concatedBase64, fileName + ".xls");
                } else {
                    downloadCSV(res.data, fileName);
                }
                setIsLoad(false);
            }
        }).catch((e: string) => {
            console.log(e);
        });
    }

    useEffect(() => {
        searchByText(0, debouncedSearch, isStatusId);
    }, [offsetStart, rowsPerPage, isStatusId, fromDate, toDate]);


    return (
        <React.Fragment>
            <div className="page-content">
                <CustomLoader isOpen={isload} />
                <Container fluid>
                    <div>
                        <h5 className="fw-semibold text-dofy dofy-admin-font-md" style={{ whiteSpace: "nowrap" }}>CORPORATE TRADE-IN</h5>
                    </div>
                    <StatusStatsFilters statusList={statusList} onClick={(id: any) => { setIsStatusId(id); }} statusName={statusName} onExport={getCorporateTradeInExport} onFromDateChange={(value: any) => setFromDate(value)} onToDateChange={(value: any) => setToDate(value)} CreatedFromDateLabel="Created From Date" CreatedToDateLabel="Created To Date" />
                    <Row>
                        <Col xl={12}>
                            <CustomDataTable
                                isPagination={corporateData[0]?.TotalRowsCount > 50 ? true : true}
                                customPageSize={50}
                                isActionEdit={false}
                                isActionDelete={false}
                                editHandler={undefined}
                                linkBtnhandler={editHandler}
                                isGlobalFilter={true}
                                searchHandler={searchHandler}
                                onColumnSortChange={onColumnSortChange}
                                canShowButton1={false}
                                selectedPage={pagination}
                                canShowButton2={false}
                                deleteHandler={undefined}
                                createHandler={undefined}
                                path={''}
                                firstBtnName={''}
                                specialGrid={false}
                                recordsCount={corporateData[0]?.TotalRowsCount}
                                pageSize={rowsPerPage}
                                columns={columns}
                                data={corporateData}
                                rowsPerPage={rowsPerPage}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                                offsetStart={offsetStart}
                                setOffsetStart={setOffsetStart}
                            />
                        </Col>
                    </Row>
                    <Modal size='lg' isOpen={editModal > 0} centered>
                        <ModalHeader toggle={() => { setEditModal(0) }}>
                            <div className=''>
                                <i className='fas fa-user-edit text-dofy me-2 font-size-15'></i>
                                <span className='font-size-16 fw-semibold text-dofy'>Corporate Trade-In Edit</span>
                                {code?.CorporateTradeInCode && (
                                    <span className={`badge rounded-pill badge-soft-info font-size-8 fw-bolder px-2 pt-2`} style={{ marginLeft: '20px' }}>
                                        <p style={{ color: "#1e4495", fontWeight: 'bold', fontSize: '15px', marginBottom: '8px' }}>Code: {code.CorporateTradeInCode}</p>
                                    </span>
                                )}
                            </div>
                        </ModalHeader>
                        <ModalBody>
                            <CorporateTrendPopUp Id={editModal} setEditModel={setEditModal} requestData={searchByText} statusList={statusList} statusId={isStatusId} />
                        </ModalBody>
                    </Modal>
                </Container >
            </div >
        </React.Fragment>
    )
}

export default CorporateInTrade